<template>
  <button
    class="boton-new"
    :class="{ [getClassSize()]: true, [getClassType()]: true, 'w-full': fullWidth  }"
    @click="handleClick"
    :disabled="disabled"
  >
    {{ title }}
  </button>
</template>

<script>
export default {
  props:{
    title: {
      type: String,
      default: 'button'
    },
    size: {
      type: String,
      default: 'medium'
    },
    type: {
      type: String,
      default: 'primario'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    fullWidth:{
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleClick(){
      this.$emit('onClick')
    },
    getClassSize(){
      if(this.size === 'large'){
        return 'boton-new-largo'
      } else if(this.size === 'small') {
        return 'boton-new-pequeno'
      } else {
        return 'boton-new-mediano'
      }
    },
    getClassType(){
      if (this.type === 'primario'){
        return 'boton-new-primario'
      } else if(this.type === 'secundario') {
        return 'boton-new-secundario'
      } else if(this.type === 'terciario') {
        return 'boton-new-terciario'
      } else if(this.type === 'text') {
        return 'boton-new-text'
      } else {
        return 'boton-new-primario'
      }
    },
  }

}

</script>

<style scoped lang="scss">
  .boton-new{
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 100px;
  }

  .boton-new-largo{
    padding: 0 32px;
    height: 60px;
    width: auto;
    font-size: 20px;
    line-height: 28px;
  }
  .boton-new-mediano{
    padding: 0 24px;
    height: 48px;
    width: auto;
    font-size: 16px;
    line-height: 18px;
  }
  .boton-new-pequeno{
    padding: 0 16px;
    height: 32px;
    width: auto;
    font-size: 14px;
    line-height: 22px;
  }

  .boton-new-primario{
    background-color: $morado50;
    border: solid 4px $neutralwhite;
    color: $neutralwhite;
    &:hover{
      background-color: $morado30;
    }
    &:active{
      background-color: $morado90;
    }
    &:focus{
      background-color: $morado50; 
      border: solid 4px grey;
    }
    &:disabled {
      background-color: #5924661a;
    }
  }
  .boton-new-secundario{
    background-color: $colorTerciario;
    border: solid 5px $neutralwhite;
    color: $neutralwhite;
    &:hover{
      background-color: $colorTerciarioLigero;
    }
    &:active{
      background-color: $colorTerciarioMedio;
    }
    &:focus{
      background-color: $colorTerciario;
      border: solid 5px grey;
    }
    &:disabled {
      background-color: rgba(12, 11, 11, 0.24);
    }
  }
  .boton-new-terciario{
    background-color: $neutralwhite;
    border: solid 3px $colorTerciario;
    color: $colorTerciario;
    &:hover{
      color: $colorTerciarioLigero;
      border: solid 3px $colorTerciarioLigero;
    }
    &:active{
      color: $colorTerciarioMedio;
      border: solid 3px $colorTerciarioMedio;
    }
    &:focus{
      background-color: $neutralwhite;
      color: $colorTerciario;
      border: solid 5px grey;
    }
    &:disabled {
      background-color: rgba(255, 255, 255, 0.24);
    }
  }
  .boton-new-text{
    background-color: $neutralwhite;
    color: $colorTerciario;
    &:hover{
      color: $morado50;
      background-color: $morado10;
    }
    &:active{
      color: $neutralwhite;
      background-color: $morado50;
    }
    &:focus{
      color: $colorTerciario;
      border: solid 5px grey;
    }
    &:disabled {
      background-color: rgba(255, 255, 255, 0.24);
    }
  }
  .w-full{
    width: 100% !important;
  }
</style>